import React from 'react'
import AppMain_MetaData from "@shared/AppMain_MetaData";

export default function AppMain() {
    return (
        <div>
            AppMain
            <p>{AppMain_MetaData()}</p>            
        </div>
    )
}
